import BrandsCenteredContent from 'components/BrandsCenteredContent';
import Skeleton from 'components/Skeleton';
import useDevice from 'hooks/useDeviceType';
import useStyles from './styles';

const BrandsControlledCarouselSkeleton = () => {
  const styles = useStyles();
  const { isTablet, isDesktop } = useDevice();
  const NUMBER_OF_SLIDES = isTablet || isDesktop ? 4 : 2;

  const skeletonItems = Array.from({ length: NUMBER_OF_SLIDES }, (_, index) => (
    <Skeleton key={`skeleton-item-${index}`} className={styles.skeletonItem} />
  ));

  return (
    <div data-testid="brands-controlled-carousel-skeleton">
      <BrandsCenteredContent>
        <div className={styles.skeleton}>{skeletonItems}</div>
      </BrandsCenteredContent>
    </div>
  );
};

export default BrandsControlledCarouselSkeleton;
